import { render, staticRenderFns } from "./PageArea.vue?vue&type=template&id=81bac6ee&scoped=true&"
import script from "./PageArea.vue?vue&type=script&lang=js&"
export * from "./PageArea.vue?vue&type=script&lang=js&"
import style0 from "./PageArea.vue?vue&type=style&index=0&id=81bac6ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bac6ee",
  null
  
)

export default component.exports